/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BookAppointmentDto } from '../models';
import { CreateServiceFormDto } from '../models';
import { CreateSubmissionDto } from '../models';
import { ServiceAppointment } from '../models';
import { ServiceConsentTemplate } from '../models';
import { ServiceForm } from '../models';
import { ServiceSubmission } from '../models';
import { UpdateServiceFormDto } from '../models';
import { UpdateSubmissionDto } from '../models';
import { UpsertConsentTemplateDto } from '../models';
/**
 * ServiceFormsApi - axios parameter creator
 * @export
 */
export const ServiceFormsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Book an appointment slot (public, used by the pharmacy website)
         * @param {BookAppointmentDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookAppointment: async (body: BookAppointmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling bookAppointment.');
            }
            const localVarPath = `/service-forms/appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers ||= {})['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel an appointment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling cancelAppointment.');
            }
            const localVarPath = `/service-forms/appointments/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a service form (custom or from a catalog template)
         * @param {CreateServiceFormDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createForm: async (body: CreateServiceFormDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createForm.');
            }
            const localVarPath = `/service-forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers ||= {})['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit a service form (public, used by the pharmacy website)
         * @param {CreateSubmissionDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubmission: async (body: CreateSubmissionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createSubmission.');
            }
            const localVarPath = `/service-forms/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers ||= {})['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a service form
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteForm: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteForm.');
            }
            const localVarPath = `/service-forms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a submission
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubmission: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteSubmission.');
            }
            const localVarPath = `/service-forms/submissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List appointments for the store (optionally for one date)
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointments: async (date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            if (date === null || date === undefined) {
                throw new RequiredError('date','Required parameter date was null or undefined when calling getAppointments.');
            }
            const localVarPath = `/service-forms/appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the catalog of default service form templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalog: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/service-forms/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the store shared vaccine consent template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentTemplate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/service-forms/consent-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single service form
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForm: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getForm.');
            }
            const localVarPath = `/service-forms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List service forms for the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForms: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/service-forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List active service forms for the storefront (optionally by category)
         * @param {string} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicForms: async (category: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError('category','Required parameter category was null or undefined when calling getPublicForms.');
            }
            const localVarPath = `/service-forms/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Available booking slots for a form on a given date
         * @param {string} id 
         * @param {string} date 
         * @param {string} duration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlots: async (id: string, date: string, duration: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getSlots.');
            }
            // verify required parameter 'date' is not null or undefined
            if (date === null || date === undefined) {
                throw new RequiredError('date','Required parameter date was null or undefined when calling getSlots.');
            }
            // verify required parameter 'duration' is not null or undefined
            if (duration === null || duration === undefined) {
                throw new RequiredError('duration','Required parameter duration was null or undefined when calling getSlots.');
            }
            const localVarPath = `/service-forms/{id}/slots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (duration !== undefined) {
                localVarQueryParameter['duration'] = duration;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List service form submissions for the store
         * @param {string} serviceForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmissions: async (serviceForm: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceForm' is not null or undefined
            if (serviceForm === null || serviceForm === undefined) {
                throw new RequiredError('serviceForm','Required parameter serviceForm was null or undefined when calling getSubmissions.');
            }
            const localVarPath = `/service-forms/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            if (serviceForm !== undefined) {
                localVarQueryParameter['serviceForm'] = serviceForm;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a service form
         * @param {UpdateServiceFormDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateForm: async (body: UpdateServiceFormDto, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateForm.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateForm.');
            }
            const localVarPath = `/service-forms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers ||= {})['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a submission status / admin notes
         * @param {UpdateSubmissionDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubmission: async (body: UpdateSubmissionDto, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateSubmission.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateSubmission.');
            }
            const localVarPath = `/service-forms/submissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers ||= {})['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or update the store shared vaccine consent template
         * @param {UpsertConsentTemplateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertConsentTemplate: async (body: UpsertConsentTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling upsertConsentTemplate.');
            }
            const localVarPath = `/service-forms/consent-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-store-key required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("x-store-key")
                    : await configuration.apiKey;
                localVarHeaderParameter["x-store-key"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers ||= {})['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceFormsApi - functional programming interface
 * @export
 */
export const ServiceFormsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Book an appointment slot (public, used by the pharmacy website)
         * @param {BookAppointmentDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookAppointment(body: BookAppointmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ServiceAppointment>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).bookAppointment(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Cancel an appointment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAppointment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ServiceAppointment>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).cancelAppointment(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create a service form (custom or from a catalog template)
         * @param {CreateServiceFormDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createForm(body: CreateServiceFormDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ServiceForm>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).createForm(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Submit a service form (public, used by the pharmacy website)
         * @param {CreateSubmissionDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubmission(body: CreateSubmissionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ServiceSubmission>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).createSubmission(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete a service form
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteForm(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).deleteForm(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete a submission
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubmission(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).deleteSubmission(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary List appointments for the store (optionally for one date)
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointments(date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ServiceAppointment>>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).getAppointments(date, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the catalog of default service form templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalog(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).getCatalog(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the store shared vaccine consent template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsentTemplate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ServiceConsentTemplate>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).getConsentTemplate(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a single service form
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForm(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ServiceForm>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).getForm(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary List service forms for the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForms(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ServiceForm>>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).getForms(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary List active service forms for the storefront (optionally by category)
         * @param {string} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicForms(category: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ServiceForm>>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).getPublicForms(category, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Available booking slots for a form on a given date
         * @param {string} id 
         * @param {string} date 
         * @param {string} duration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlots(id: string, date: string, duration: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).getSlots(id, date, duration, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary List service form submissions for the store
         * @param {string} serviceForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubmissions(serviceForm: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ServiceSubmission>>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).getSubmissions(serviceForm, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a service form
         * @param {UpdateServiceFormDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateForm(body: UpdateServiceFormDto, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ServiceForm>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).updateForm(body, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update a submission status / admin notes
         * @param {UpdateSubmissionDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubmission(body: UpdateSubmissionDto, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ServiceSubmission>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).updateSubmission(body, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create or update the store shared vaccine consent template
         * @param {UpsertConsentTemplateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertConsentTemplate(body: UpsertConsentTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ServiceConsentTemplate>>> {
            const localVarAxiosArgs = await ServiceFormsApiAxiosParamCreator(configuration).upsertConsentTemplate(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ServiceFormsApi - factory interface
 * @export
 */
export const ServiceFormsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Book an appointment slot (public, used by the pharmacy website)
         * @param {BookAppointmentDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookAppointment(body: BookAppointmentDto, options?: AxiosRequestConfig): Promise<AxiosResponse<ServiceAppointment>> {
            return ServiceFormsApiFp(configuration).bookAppointment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel an appointment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAppointment(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<ServiceAppointment>> {
            return ServiceFormsApiFp(configuration).cancelAppointment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a service form (custom or from a catalog template)
         * @param {CreateServiceFormDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createForm(body: CreateServiceFormDto, options?: AxiosRequestConfig): Promise<AxiosResponse<ServiceForm>> {
            return ServiceFormsApiFp(configuration).createForm(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit a service form (public, used by the pharmacy website)
         * @param {CreateSubmissionDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubmission(body: CreateSubmissionDto, options?: AxiosRequestConfig): Promise<AxiosResponse<ServiceSubmission>> {
            return ServiceFormsApiFp(configuration).createSubmission(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a service form
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteForm(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ServiceFormsApiFp(configuration).deleteForm(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a submission
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubmission(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ServiceFormsApiFp(configuration).deleteSubmission(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List appointments for the store (optionally for one date)
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppointments(date: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ServiceAppointment>>> {
            return ServiceFormsApiFp(configuration).getAppointments(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the catalog of default service form templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalog(options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ServiceFormsApiFp(configuration).getCatalog(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the store shared vaccine consent template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsentTemplate(options?: AxiosRequestConfig): Promise<AxiosResponse<ServiceConsentTemplate>> {
            return ServiceFormsApiFp(configuration).getConsentTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single service form
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForm(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<ServiceForm>> {
            return ServiceFormsApiFp(configuration).getForm(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List service forms for the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForms(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ServiceForm>>> {
            return ServiceFormsApiFp(configuration).getForms(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List active service forms for the storefront (optionally by category)
         * @param {string} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicForms(category: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ServiceForm>>> {
            return ServiceFormsApiFp(configuration).getPublicForms(category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Available booking slots for a form on a given date
         * @param {string} id 
         * @param {string} date 
         * @param {string} duration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlots(id: string, date: string, duration: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ServiceFormsApiFp(configuration).getSlots(id, date, duration, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List service form submissions for the store
         * @param {string} serviceForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubmissions(serviceForm: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ServiceSubmission>>> {
            return ServiceFormsApiFp(configuration).getSubmissions(serviceForm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a service form
         * @param {UpdateServiceFormDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateForm(body: UpdateServiceFormDto, id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<ServiceForm>> {
            return ServiceFormsApiFp(configuration).updateForm(body, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a submission status / admin notes
         * @param {UpdateSubmissionDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubmission(body: UpdateSubmissionDto, id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<ServiceSubmission>> {
            return ServiceFormsApiFp(configuration).updateSubmission(body, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or update the store shared vaccine consent template
         * @param {UpsertConsentTemplateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertConsentTemplate(body: UpsertConsentTemplateDto, options?: AxiosRequestConfig): Promise<AxiosResponse<ServiceConsentTemplate>> {
            return ServiceFormsApiFp(configuration).upsertConsentTemplate(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceFormsApi - object-oriented interface
 * @export
 * @class ServiceFormsApi
 * @extends {BaseAPI}
 */
export class ServiceFormsApi extends BaseAPI {
    /**
     * 
     * @summary Book an appointment slot (public, used by the pharmacy website)
     * @param {BookAppointmentDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async bookAppointment(body: BookAppointmentDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<ServiceAppointment>> {
        return ServiceFormsApiFp(this.configuration).bookAppointment(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Cancel an appointment
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async cancelAppointment(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<ServiceAppointment>> {
        return ServiceFormsApiFp(this.configuration).cancelAppointment(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Create a service form (custom or from a catalog template)
     * @param {CreateServiceFormDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async createForm(body: CreateServiceFormDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<ServiceForm>> {
        return ServiceFormsApiFp(this.configuration).createForm(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Submit a service form (public, used by the pharmacy website)
     * @param {CreateSubmissionDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async createSubmission(body: CreateSubmissionDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<ServiceSubmission>> {
        return ServiceFormsApiFp(this.configuration).createSubmission(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Delete a service form
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async deleteForm(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ServiceFormsApiFp(this.configuration).deleteForm(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Delete a submission
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async deleteSubmission(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ServiceFormsApiFp(this.configuration).deleteSubmission(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary List appointments for the store (optionally for one date)
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async getAppointments(date: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ServiceAppointment>>> {
        return ServiceFormsApiFp(this.configuration).getAppointments(date, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get the catalog of default service form templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async getCatalog(options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ServiceFormsApiFp(this.configuration).getCatalog(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get the store shared vaccine consent template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async getConsentTemplate(options?: AxiosRequestConfig) : Promise<AxiosResponse<ServiceConsentTemplate>> {
        return ServiceFormsApiFp(this.configuration).getConsentTemplate(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get a single service form
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async getForm(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<ServiceForm>> {
        return ServiceFormsApiFp(this.configuration).getForm(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary List service forms for the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async getForms(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ServiceForm>>> {
        return ServiceFormsApiFp(this.configuration).getForms(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary List active service forms for the storefront (optionally by category)
     * @param {string} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async getPublicForms(category: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ServiceForm>>> {
        return ServiceFormsApiFp(this.configuration).getPublicForms(category, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Available booking slots for a form on a given date
     * @param {string} id 
     * @param {string} date 
     * @param {string} duration 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async getSlots(id: string, date: string, duration: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ServiceFormsApiFp(this.configuration).getSlots(id, date, duration, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary List service form submissions for the store
     * @param {string} serviceForm 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async getSubmissions(serviceForm: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ServiceSubmission>>> {
        return ServiceFormsApiFp(this.configuration).getSubmissions(serviceForm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Update a service form
     * @param {UpdateServiceFormDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async updateForm(body: UpdateServiceFormDto, id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<ServiceForm>> {
        return ServiceFormsApiFp(this.configuration).updateForm(body, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Update a submission status / admin notes
     * @param {UpdateSubmissionDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async updateSubmission(body: UpdateSubmissionDto, id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<ServiceSubmission>> {
        return ServiceFormsApiFp(this.configuration).updateSubmission(body, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Create or update the store shared vaccine consent template
     * @param {UpsertConsentTemplateDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceFormsApi
     */
    public async upsertConsentTemplate(body: UpsertConsentTemplateDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<ServiceConsentTemplate>> {
        return ServiceFormsApiFp(this.configuration).upsertConsentTemplate(body, options).then((request) => request(this.axios, this.basePath));
    }
}
